import { RefObject, useEffect } from 'react';

import { DomEventEnum } from '../types/shell';

// Maps a vertical wheel onto scrollLeft, claiming the event only while the strip can still travel
// in that direction so at either end the wheel falls through to the scrolling drawer behind it.
// Registered non-passively so preventDefault applies. `isEnabled` re-attaches when the strip is
// rendered conditionally and mounts after the hook first ran.
export const useHorizontalWheelScroll = (ref: RefObject<HTMLElement>, isEnabled = true) => {
  useEffect(() => {
    const el = ref.current;

    if (!el || !isEnabled) {
      return;
    }

    const handleWheel = (e: WheelEvent) => {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) {
        return;
      }

      const maxScroll = el.scrollWidth - el.clientWidth;

      if (maxScroll <= 0) {
        return;
      }

      const canTravel = e.deltaY > 0 ? el.scrollLeft < maxScroll : el.scrollLeft > 0;

      if (!canTravel) {
        return;
      }

      e.preventDefault();
      el.scrollLeft += e.deltaY;
    };

    el.addEventListener(DomEventEnum.Wheel, handleWheel, { passive: false });

    return () => el.removeEventListener(DomEventEnum.Wheel, handleWheel);
  }, [ref, isEnabled]);
};
